import { STRAPI_URL, parseErrorMessage, strapiAuthHeaders } from './strapi';
import {
  strapiCreateDynamicEntity,
  strapiDeleteDynamicEntity,
  strapiUpdateDynamicEntity,
  type DynamicEntityRow,
  normalizeDynamicRow,
} from './strapiDynamicEntity';

function asRecord(v: unknown): Record<string, unknown> | null {
  if (typeof v !== 'object' || v === null || Array.isArray(v)) return null;
  return v as Record<string, unknown>;
}

function parseListBody(res: Response, body: unknown): Record<string, unknown>[] {
  if (!res.ok) throw new Error(parseErrorMessage(body, res.status));
  if (Array.isArray(body)) return body as Record<string, unknown>[];
  const b = asRecord(body);
  if (b && Array.isArray(b.data)) return b.data as Record<string, unknown>[];
  return [];
}

const API = 'customer-samples';
const POPULATE = '*';

export async function strapiListCustomerSamplesForCustomer(
  jwt: string,
  customerDocumentId: string,
): Promise<DynamicEntityRow[]> {
  const params = new URLSearchParams({
    'pagination[pageSize]': '200',
    'pagination[page]': '1',
    sort: 'updatedAt:desc',
    populate: POPULATE,
    'filters[customer][documentId][$eq]': customerDocumentId,
  });
  const res = await fetch(`${STRAPI_URL}/api/${API}?${params}`, { headers: strapiAuthHeaders(jwt) });
  const body = await res.json().catch(() => ({}));
  return parseListBody(res, body).map((r) => normalizeDynamicRow(r));
}

export type CustomerSampleWrite = {
  location_name: string;
  latitude?: number | null;
  longitude?: number | null;
};

export async function strapiCreateCustomerSampleForCustomer(
  jwt: string,
  customerDocumentId: string,
  data: CustomerSampleWrite,
): Promise<DynamicEntityRow> {
  const payload: Record<string, unknown> = {
    location_name: data.location_name.trim(),
    customer: { connect: [customerDocumentId] },
  };
  if (data.latitude != null && Number.isFinite(Number(data.latitude))) {
    payload.latitude = Number(data.latitude);
  }
  if (data.longitude != null && Number.isFinite(Number(data.longitude))) {
    payload.longitude = Number(data.longitude);
  }
  return strapiCreateDynamicEntity(jwt, API, payload, POPULATE);
}

export async function strapiUpdateCustomerSample(
  jwt: string,
  documentId: string,
  data: CustomerSampleWrite,
): Promise<DynamicEntityRow> {
  const payload: Record<string, unknown> = {
    location_name: data.location_name.trim(),
  };
  if (data.latitude != null && Number.isFinite(Number(data.latitude))) {
    payload.latitude = Number(data.latitude);
  }
  if (data.longitude != null && Number.isFinite(Number(data.longitude))) {
    payload.longitude = Number(data.longitude);
  }
  return strapiUpdateDynamicEntity(jwt, API, documentId, payload, POPULATE);
}

export async function strapiDeleteCustomerSample(jwt: string, documentId: string): Promise<void> {
  return strapiDeleteDynamicEntity(jwt, API, documentId);
}
